module.exports = __webpack_public_path__ + "img/apple-pie-2.0531180f.svg";